import { Switch, Route as ReactRouterRoute } from 'react-router-dom';

import { NotFound } from '../../components/NotFound';
import { Preview } from '../../components/Preview';
import { PREVIEW_LINK_RESOLVER } from '../../services/prismic';
import { useRoutes } from '../hooks/useRoutes';

export interface StaticPageProps {
  url: string;
  id: string;
}

export interface StaticRoutesProps {
  page: (props: StaticPageProps) => JSX.Element | null;
}

export function StaticRoutes({ page: Page }: StaticRoutesProps) {
  const routes = useRoutes();

  return (
    <Switch>
      <ReactRouterRoute path={PREVIEW_LINK_RESOLVER} component={Preview} />

      {routes.map(route => {
        return (
          <ReactRouterRoute key={route.url} exact path={route.url}>
            <Page id={route.id} url={route.url} />
          </ReactRouterRoute>
        );
      })}

      {/* TODO: Remove index.html routes when cloudflare is enabled */}
      {routes.map(route => {
        const path = `${route.url}/index.html`;

        return (
          <ReactRouterRoute key={path} path={path} exact>
            <Page id={route.id} url={route.url} />
          </ReactRouterRoute>
        );
      })}

      <ReactRouterRoute path="*">
        <NotFound />
      </ReactRouterRoute>
    </Switch>
  );
}
